import { useState, type SyntheticEvent } from "react";

import { ApiError } from "@island/browser-client";
import { useSession } from "../session/SessionContext.js";

/**
 * Staff sign-in.
 *
 * The failure message is deliberately the one the API returns, which does not
 * distinguish an unknown address from a wrong password. Making the form more helpful
 * than the API would turn it back into the account-enumeration oracle the API takes
 * care to avoid being.
 */
export function LoginView() {
  const { signIn } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: SyntheticEvent): Promise<void> {
    event.preventDefault();
    setError(null);
    setBusy(true);

    try {
      await signIn(email, password, rememberMe);
    } catch (caught) {
      setError(
        caught instanceof ApiError ? caught.message : "Sign-in is unavailable. Please try again.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="centered">
      <form className="card" onSubmit={(event) => void submit(event)}>
        <h1 className="brand" style={{ margin: 0 }}>
          Island Peptides Support
        </h1>

        <label>
          <span className="small muted">Email</span>
          <input
            type="email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            autoComplete="username"
            required
          />
        </label>

        <label>
          <span className="small muted">Password</span>
          <input
            type="password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            autoComplete="current-password"
            required
          />
        </label>

        <label className="row small">
          <input
            type="checkbox"
            style={{ width: "auto" }}
            checked={rememberMe}
            onChange={(event) => {
              setRememberMe(event.target.checked);
            }}
          />
          <span>Keep me signed in for 90 days</span>
        </label>

        {error !== null && <p className="error">{error}</p>}

        <button className="primary" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
